import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-block-login-landing',
    templateUrl: './block-login-landing.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './block-login-landing.component.scss',
})
export class BlockLoginLandingComponent extends BlockAbstractComponent implements OnInit {
    override ngOnInit(): void {
        super.ngOnInit();

        if (this.block?.data?.subHeading && this.block.data.subHeading.length > 85) {
            this.block.data.subHeading = this.block.data.subHeading.substring(0, 85);
        }
        if (this.block?.data?.heading && this.block.data.heading.length > 20) {
            this.block.data.heading = this.block.data.heading.substring(0, 20);
        }
    }

    getHeaderColor(headerColor: string) {
        switch (headerColor) {
            case 'black':
                return 'var(--bs-black)';
            case 'primary':
                return 'var(--color-primary)';
            case 'secondary':
                return 'var(--color-secondary)';
            case 'dark grey':
                return 'var(--color-dark-grey)';
            default:
                return 'var(--bs-black)';
        }
    }
}
